import { api, datesToISO, parseBoolean } from "@";

// Fetch messages with pagination and search filters
export const getMessages = (page = 1, pageSize = "", search) => {
  const { title, isSended, date } = search;
  return api.post(`/api/adminSms/previous-message`, {
    page,
    pageSize,
    searchKey: title,
    createdOn: datesToISO(date),
    isSent: parseBoolean(isSended),
  });
};

// Resend all failed messages within a date range
export const resendAll = ({ toDate, fromDate }) => {
  return api.put(`/api/AdminSms/send-failed-messages`, {
    toDate: datesToISO(toDate),
    fromDate: datesToISO(fromDate),
  });
};

// Resend a single failed message by ID
export const resendSingle = (id) =>
  api.put(`/api/AdminSms/send-failed-message/${id}`);
